<div class="fullscreen-panel card-select-panel-wrapper">
  <div class="card-select-panel-content-row" fxLayout="column"   fxLayoutAlign="center center" >
    <span class="select-title">{{title}}</span>
  </div>
  <app-thumbnail-gallery [sourceCards]="cardsToSelect" [galleryMode]="GALLERY_MODE.SELECTION" [showCardPrice]="true" (cardClicked)="onCardSelected($event)" (cardPriceTagClicked)="onCardSelected($event)" class="low-margin-title last-slider"
  [ngClass]="{'single-select': true}"></app-thumbnail-gallery>
</div>
<div class="background-overlay dark-background-overscroll"></div>
